import React from "react";
import { CheckCircle } from "lucide-react";
import { FaChartLine, FaExchangeAlt } from "react-icons/fa";
import { SiAffinitydesigner, SiExpertsexchange } from "react-icons/si";


const tradingPlatforms = [
    {
        name: "MT4",
        icon: <img src="/mt4.png" alt="MT4" className="w-20 h-20 rounded-full" />,
    },
    {
        name: "MT5",
        icon:<img src="/mt5.jpg" alt="MT5" className="w-20 h-20 rounded-full" />,
    },
    {
        name: "CTrader",
        icon: <img src="/cTrader.jpg" alt="CTrader" className="w-20 h-20 rounded-full" />,
    },
    {
        name: "Vertex",
        icon: <img src="/vertex.png" alt="Vertex" className="w-20 h-20 rounded-full" />,
    },
    {
        name: "Ntrader",
        icon: <img src="/ntrader.webp" alt="ntrader" className="w-20 h-20 rounded-full" />,
    },
    {
        name: "Wintrado",
        icon: <img src="/wintrado.jpg" alt="Wintrado" className="w-20 h-20 rounded-full" />,
    },
];

const features = [
    {
        title: "Deposit and Withdrawal Management",
        description:
            "Efficiently manage client deposits and withdrawals, with automated processing and real-time updates.",
        borderColor: "border-blue-500",
    },
    {
        title: "IB Commission Management",
        description:
            "Easily track and manage Introducing Broker (IB) commissions, with automated calculations and payouts.",
        borderColor: "border-green-500",
    },
    {
        title: "KYC Verification",
        description:
            "Streamline Know Your Customer (KYC) verification processes, ensuring compliance with regulatory requirements.",
        borderColor: "border-red-500",
    },
    {
        title: "Instant Support",
        description:
            "Provide timely and effective support to clients, with instant messaging and ticketing systems.",
        borderColor: "border-yellow-500",
    },
    {
        title: "News Updates",
        description:
            "Keep clients informed about market news and updates, with automated news feeds and notifications.",
        borderColor: "border-purple-500",
    },
    {
        title: "Back Office Management",
        description:
            "Efficiently manage back office operations, including account management, reporting, and analytics.",
        borderColor: "border-indigo-500",
    },
];

const keyFeatures = [
    {
        title: "Streamline Operations",
        description:
            "Automate tasks, manage leads, and track customer interactions.",
        icon: "⚙️",
    },
    {
        title: "Enhance Customer Experience",
        description:
            "Provide personalized support, resolve issues efficiently, and increase customer satisfaction.",
        icon: "🤝",
    },
    {
        title: "Gain Valuable Insights",
        description:
            "Analyze customer behavior, track sales performance, and make data-driven decisions.",
        icon: "📊",
    },
    {
        title: "Increase Efficiency",
        description:
            "Reduce manual errors, automate workflows, and boost productivity.",
        icon: "⚡",
    },
];
const forexFeatures = [
    {
        title: "User-Friendly Interface",
        description:
            "Easy to navigate and use, even for non-technical users.",
        icon: "🖥️",
    },
    {
        title: "Customizable",
        description:
            "Tailored to meet your specific business needs.",
        icon: "⚙️",
    },
    {
        title: "Scalable",
        description:
            "Grows with your business, handling increased traffic and customer growth.",
        icon: "📈",
    },
    {
        title: "Secure",
        description:
            "Robust security measures to protect customer data and prevent online threats.",
        icon: "🔒",
    },
];



const ForexCRM = () => {
    return (
        <div className="container mx-auto px-8 pt-4 lg:px-16">
            {/* Header */}
            <div className="space-y-3">
                <h1 className="text-4xl font-bold text-center text-sky-400">
                    Forex CRM Solutions
                </h1>
                <h1 className="text-2xl font-semibold ">Seamless Integration with Popular Trading Platforms
                </h1>
                <h1 className="font-semibold text-gray-600">Our Forex CRM solutions integrate seamlessly with:
                </h1>
            </div>



            {/* Icons Grid */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6 justify-center">
                {tradingPlatforms.map((platform, index) => (
                    <div key={index} className="flex flex-col items-center space-y-3 p-4 border border-gray-300 rounded-lg shadow-md bg-white hover:shadow-lg transition">
                        {platform.icon}
                        <span className="text-lg font-medium text-gray-800">
                            {platform.name}
                        </span>
                    </div>
                ))}
            </div>
            <div>
                <h1 className="text-2xl pt-10 text-text-justify pb-2 font-semibold "> Empower Your Forex Brokerage with Our Cutting-Edge CRM Solutions:
                </h1>
                <p className="text-sm text-gray-600">At Infyst Technologies, we understand the importance of a robust CRM system in streamlining your Forex brokerage operations. Our team of experts, with over 10 years of experience, has designed a user-friendly CRM solution specifically for Forex brokers like you.
                </p>
                <h1 className="text-2xl pt-5 font-semibold "> Comprehensive Features for Efficient Brokerage Management
                </h1>
                <p className="text-gray-600 pb-5 text-sm font-semibold">Our Forex CRM solutions come equipped with the following features:</p>
            </div>

            {/* Grid Layout for Features */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {features.map((feature, index) => (
                    <div
                        key={index}
                        className={`bg-white shadow-md rounded-lg p-6 border-l-4 ${feature.borderColor}`}
                    >
                        <div className="flex items-center gap-3">
                            <CheckCircle className="text-gray-700 w-6 h-6" />
                            <h2 className="text-xl font-semibold text-gray-800">
                                {feature.title}
                            </h2>
                        </div>
                        <p className="text-gray-600 text-sm mt-2">{feature.description}</p>
                    </div>
                ))}
            </div>

            {/* The Power of Our Forex CRM......................... */}
            <div className="container mx-auto px-6 py-12 text-center">
                <h2 className="text-3xl font-extrabold text-black mb-8">
                    The Power of Our Forex CRM
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {keyFeatures.map((feature, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center p-6 border border-gray-300 shadow-lg rounded-lg bg-white hover:shadow-2xl transition"
                        >
                            <div className="text-4xl">{feature.icon}</div>
                            <h3 className="text-xl font-semibold text-gray-800 mt-4">
                                {feature.title}
                            </h3>
                            <p className="text-gray-600 mt-2 text-sm">{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Why to choose Us........................................ */}
            <div className="flex flex-col items-center p-6 border border-gray-300 shadow-lg rounded-lg bg-white hover:shadow-2xl transition">
                <h2 className="text-3xl font-extrabold text-black mb-8">
                    Why Choose Our Forex CRM?
                </h2>
                <div>
                    {forexFeatures.map((feature, index) => (
                        <div className="gap-5" key={index}>
                            <div className="flex items-center gap-3">
                                <div className="text-2xl">{feature.icon}</div> {/* Reduced icon size */}
                                <h3 className="text-lg font-semibold text-gray-800">{feature.title}: <span className="text-gray-600 mt-1 text-sm">
                                {feature.description}</span></h3>
                            </div>
                            
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default ForexCRM;
